
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/vlozeni-inzeratu/formular/udaje-nabidka",
      function () {
        return require("private-next-pages/vlozeni-inzeratu/formular/udaje-nabidka.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/vlozeni-inzeratu/formular/udaje-nabidka"])
      });
    }
  